import React, { FC } from 'react';
import styleModule from './RecruiterLandingTopSection.module.less';
import Link from 'next/link';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import Image from 'next/image';

import { RightOutlined } from '@ant-design/icons';
import { useUserInfo } from '../../../connection/Application';
import { Title } from '../../../components/Typogrphy/Title';
import { Text } from '../../../components/Typogrphy/Text';
import { PlusOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import background from '../../../public/recruiter/recruiter-landing/BannerImg.png';
const styles: any = styleModule;

export const RecruiterLandingTopSection: FC = () => {
  const user = useUserInfo();
  const history = useRouter();
  return (
    <section className="relative w-screen self-center flex justify-center mt-[-20px] bg-[#f6fbfa] text-[#050931]">
      <div className={styles.topSectionLeft} />
      <div className={styles.topSectionRight} />
      <div className="w-full max-w-[1600px] px-[20px] md:px-[65px] py-[40px] flex items-center z-10 flex-col lg:flex-row gap-8 lg:gap-0">
        <div className={`grow shrink z-10 ${styles.bannerTextCont}`}>
          <Title level={1} className={`mt-0 ${styles.headerText}`}>
            <Title level={3} className={styles.headerText2}>
              Grow With Us
            </Title>
            <span className={styles.topbannerHeading}>Hire the right candidate</span>
          </Title>
          <Text style={{ color: '#5B6272', fontSize: 20 }} type={'secondary'}>
            <span className={styles.secondarytext}>
              Experience our award-winning recruitment solution.{' '}
            </span>
          </Text>

          <div>
            <div className={styles.mobilebtn}>
              <Button
                size={'middle'}
                icon={<PlusOutlined />}
                type={'primary'}
                onClick={() => history.push('/recruiter/create')}
                className={styles.bannerButton}>
                <b style={{ fontWeight: 'bolder', paddingLeft: '15px' }}>Post a Job</b>
              </Button>
            </div>
            <div style={{ marginTop: '50px' }} className={styles.deskbtn}>
              {/* <Button
                size={'large'}
                icon={<PlusOutlined />}
                type={'primary'}
                onClick={() => history.push('/recruiter/create')}
                className={styles.bannerButton}>
                <b style={{ fontWeight: 'bolder', paddingLeft: '15px' }}>Post a Job</b>
              </Button> */}
              <Button
                className={styles.searchBtn}
                size={'large'}
                type={'primary'}
                onClick={() => history.push('/recruiter/create')}>
                <div className="flex gap-2 hover:gap-4 transition-all mx-[-32px] my-[-16px] px-[32px] py-[16px] justify-center">
                  <span>Post a Job</span>
                  <RightOutlined />
                </div>
              </Button>
            </div>
          </div>
        </div>
        <div
          className={`grow shrink flex items-center justify-center z-0 ${styles.bannerImageCont}`}>
          <div className={styles.topRightDiv}>
            <Image
              src={background}
              alt={'Banner Background'}
              className={styles.bannerImage}
              // style={{
              //   color: 'transparent',
              //   position: 'inherit',
              //   width: '600px',
              //   height: '500px',
              //   margin: 'auto',
              // }}
            />
            {/* <Image src={background} alt={'Banner Background'} /> */}
          </div>
        </div>
      </div>
    </section>
  );
};
